import React from 'react';
import Icon from './Icon';
import { profile, ownedProjects } from '../data/portfolio';

const projectLabels = {
  renderer: { title: 'Video Renderer', detail: 'Performance & memory' },
  'qa-agents': { title: 'AI QA Agents', detail: 'Architecture proposal' },
  myclassroom: { title: 'Myclassroom', detail: 'Backend platform' },
};

export default function Hero() {
  const renderer = ownedProjects.find(project => project.id === 'renderer');
  const benchmark = renderer.report.benchmarks.find(item => item.id === 'image');
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-running-head"><span className="eyebrow">{profile.role} / A portfolio of owned work</span><span className="location"><span aria-hidden="true" className="location-dot" />{profile.location}</span></div>
      <div className="hero-grid">
        <div className="hero-copy">
          <h1 id="hero-title" tabIndex={-1}>Engineering<br />that earns<br /><em>its keep.</em></h1>
          <p className="hero-description">I’m <strong>Vaibhav Lehra.</strong> I build backend platforms and make production systems faster, leaner, and easier to run.</p>
          <p className="hero-subcopy">Video rendering. Learning platforms. Thoughtful QA architecture. Here’s the work I own.</p>
          <div className="hero-actions"><a className="button" href="/#work">Explore my work <Icon kind="diagonal" /></a><a className="text-link" href={profile.resume} download>Download resume <Icon kind="download" /></a></div>
        </div>
        <a className="hero-art" href="/work/renderer/" aria-label="Explore my production-deployed Video Renderer project, measured at 65 to 28 seconds in matched staging runs">
          <div className="hero-art-top"><span>PRODUCTION DEPLOYMENT / {renderer.number}</span><Icon kind="diagonal" /></div>
          <span className="hero-project-name">Dynamic Product Ads / Renderer</span>
          <h2>Every frame.<br /><em>Less overhead.</em></h2>
          <div className="renderer-timing" aria-label={`${benchmark.beforeSeconds} seconds before, ${benchmark.afterSeconds} seconds after`}>
            <div><span>Before</span><strong>{benchmark.beforeSeconds}<small>s</small></strong></div>
            <Icon />
            <div className="renderer-timing-after"><span>After</span><strong>{benchmark.afterSeconds}<small>s</small></strong></div>
          </div>
          <div className="renderer-track" aria-hidden="true">
            <div className="renderer-track-before">{Array.from({ length: 12 }, (_, index) => <i key={index} />)}</div>
            <div className="renderer-track-after">{Array.from({ length: 5 }, (_, index) => <i key={index} />)}</div>
          </div>
          <p className="hero-benchmark-note">Same template, audio, and product.<br />6-second video · matched staging runs.</p>
          <div className="hero-art-bottom"><span>{renderer.metrics[0].value} LESS RENDER TIME</span><span>Inside the rebuild <Icon /></span></div>
        </a>
      </div>
      <div className="hero-facts">
        <div><strong>{renderer.metrics[0].value}</strong><span>less render time<br />matched staging runs</span></div>
        <div><strong>{renderer.metrics[1].value}</strong><span>memory leak eliminated<br />per render job</span></div>
        <div><strong>{profile.experience}</strong><span>building across<br />AdTech & EdTech</span></div>
        <a href="/#work" className="hero-scroll" aria-label="Scroll to my owned engineering studies"><Icon kind="down" /><span>The work behind the numbers</span></a>
      </div>
      <nav className="hero-owned-links" aria-label="Featured owned projects">
        {ownedProjects.map(project => <a key={project.id} href={`/work/${project.id}/`}><span className="hero-project-number" aria-hidden="true">{project.number}</span><span><strong>{projectLabels[project.id]?.title || project.subtitle}</strong><small>{projectLabels[project.id]?.detail || project.category}</small></span><Icon kind="diagonal" /></a>)}
      </nav>
    </section>
  );
}
